enum RoutesEnum {
    LEARN,
    MISSIONS,
    PROFILE,
    CONTENT,
    QUIZ

}

export default RoutesEnum;